module.exports = __webpack_public_path__ + "media/images/global/icons/binder-c29cf0ffa06c7d9ef288155e6c6024ba.svg";